"use strict";

var themes = {
  defaultTheme: require("./default-theme"),
  learnTheme: require("./learn-theme")
};
module.exports = themes;